import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgTerrasse = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		id="terrasse_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>
				{
					`.prestation_cls_fill_none{fill:none;stroke:${color};stroke-miterlimit:40;stroke-width:10px}`
				}
			</style>
		</defs>
		<path
			className="prestation_cls_fill_none"
			d="m63.78 233.77 21.26 63.91-21.26 63.65M106.3 297.55h31.89v63.91M318.9 297.55h-31.89v63.78M361.42 233.77l-21.26 63.91 21.26 63.82M212.6 276.29v85.04M180.71 361.33h63.78M212.6 148.73v106.43M74.41 148.73 212.6 63.69l138.19 85.04H74.41z"
		/>
		<ellipse
			className="prestation_cls_fill_none"
			cx={212.6}
			cy={260.35}
			rx={85.04}
			ry={15.94}
		/>
	</svg>
)
export default SvgTerrasse
